import React, { useState, useContext } from "react";
import { CartContext } from "./CartContext";
import "./App.css";

function CheckoutPage() {
  const { cart, updateQuantity, removeFromCart } = useContext(CartContext);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let ids = cart.map((item) => item.id).join(",");
      let qtys = cart.map((item) => item.qty).join(",");

      // redirect to FLORIA checkout
      let url = `https://floriakw.com/react-checkout/?add-to-cart=${ids}&quantity=${qtys}`;
      window.location.href = url;
    } catch (err) {
      console.error("Redirect error:", err);
      alert("❌ حدث خطأ أثناء التوجيه لصفحة الدفع");
      setLoading(false);
    }
  };

  // المجموع
  const subtotal = cart.reduce((sum, item) => {
    const unit = item.variation
      ? parseFloat(item.variation.sale_price || item.variation.price || item.price || 0)
      : parseFloat(item.price || 0);
    return sum + unit * item.qty;
  }, 0);

  return (
    <div className="checkout-container">
      <div className="order-summary">
        <h2 className="checkout-title">ملخص الطلب</h2>
        {cart.length === 0 ? (
          <p>🛒 سلة التسوق فارغة</p>
        ) : (
          <>
            {/* Desktop/Table layout */}
            <div className="desktop-only">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>المنتج</th>
                    <th>الاسم</th>
                    <th>الكمية</th>
                    <th>السعر</th>
                    <th>الإجمالي</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((item) => {
                    // Compute unit price considering variation if present
                    const unitPrice = item.variation
                      ? parseFloat(item.variation.sale_price || item.variation.price || item.price || 0)
                      : parseFloat(item.price || 0);
                    return (
                    <tr key={item.id}>
                      <td>
                        <button
                          type="button"
                          className="remove-item-btn"
                          aria-label={`إزالة ${item.name}`}
                          onClick={() => removeFromCart(item.id, item.name)}
                          title="إزالة"
                        >
                          ×
                        </button>
                      </td>
                      <td>
                        {item.images && item.images[0] && (
                          <img
                            src={item.images[0].src}
                            alt={item.name}
                            className="cart-table-img"
                          />
                        )}
                      </td>
                      <td>
                        <div>{item.name}</div>
                        {item.variation && item.variation.attributes && item.variation.attributes.length > 0 && (
                          <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                            {item.variation.attributes.map((attr) => (
                              <span key={attr.name} style={{ marginInlineEnd: 8 }}>
                                <strong>{attr.name}:</strong> {attr.option}
                              </span>
                            ))}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          min="1"
                          value={item.qty}
                          onChange={(e) =>
                            updateQuantity(item.id, parseInt(e.target.value))
                          }
                          className="qty-input"
                        />
                      </td>
                      <td>{unitPrice.toFixed(2)} KWD</td>
                      <td>
                        {(unitPrice * item.qty).toFixed(2)} KWD
                      </td>
                    </tr>
                  )})}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="4" className="text-right">
                      المجموع
                    </td>
                    <td>{subtotal.toFixed(2)} KWD</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Mobile card layout */}
            <div className="mobile-only">
              <div className="mobile-cart-list">
                {cart.map((item) => {
                  const unitPrice = item.variation
                    ? parseFloat(item.variation.sale_price || item.variation.price || item.price || 0)
                    : parseFloat(item.price || 0);
                  return (
                    <div key={item.id} className="mobile-cart-card">
                      <div className="mobile-card-right">
                        {item.images && item.images[0] && (
                          <img
                            src={item.images[0].src}
                            alt={item.name}
                            className="mobile-cart-img"
                          />
                        )}
                      </div>
                      <div className="mobile-card-left">
                        <div className="mobile-card-header">
                          <div className="mobile-card-title">{item.name}</div>
                          <button
                            type="button"
                            className="remove-item-btn"
                            aria-label={`إزالة ${item.name}`}
                            onClick={() => removeFromCart(item.id, item.name)}
                            title="إزالة"
                          >
                            ×
                          </button>
                        </div>
                        {item.variation && item.variation.attributes && item.variation.attributes.length > 0 && (
                          <div className="mobile-card-attrs">
                            {item.variation.attributes.map((attr) => (
                              <span key={attr.name}>
                                <strong>{attr.name}:</strong> {attr.option}
                              </span>
                            ))}
                          </div>
                        )}
                        <div className="mobile-card-row">
                          <label>الكمية</label>
                          <input
                            type="number"
                            min="1"
                            value={item.qty}
                            onChange={(e) =>
                              updateQuantity(item.id, parseInt(e.target.value))
                            }
                            className="qty-input"
                          />
                        </div>
                        <div className="mobile-card-row">
                          <span>السعر: {unitPrice.toFixed(2)} KWD</span>
                          <span>الإجمالي: {(unitPrice * item.qty).toFixed(2)} KWD</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <button
              onClick={handleSubmit}
              className="place-order-btn"
              disabled={loading}
            >
              {loading ? "جاري التوجيه..." : "إتمام الطلب"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default CheckoutPage;
